export default __webpack_public_path__ + "static/media/main-slider-1.17641e96.png";